<div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div>
<div class="container mt-2">
    <!-- Button tabs -->
    <!-- <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-bs-toggle="tab" href="#invoice-list">Invoice</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="tab" href="#payment-list">Payment Request</a>
      </li>
    </ul> -->
    
    <!-- Tab content -->
    <!-- <div class="tab-content">
      <div id="invoice-list" class="tab-pane fade show active"> -->
        <app-invoice-list></app-invoice-list>
      <!-- </div>
      <div id="payment-list" class="tab-pane fade">
        <app-payment-list></app-payment-list>
      </div>
    </div> -->
</div>
